import React,{useState,useEffect} from 'react';
import {useDispatch,useSelector} from "react-redux";
import * as yup from 'yup';
import moment from 'moment';
import { withFormik } from 'formik';
import AddGuestForm from './AddGuestForm';
import GuestBookingList from '../List/GuestBookingList';
import GuestInvoiceList from '../List/GuestInvoiceList';
import styles2 from '../../guest.module.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {invoiceByGuest} from '../../../../../../general_redux/invoice/actions';

function AddGuests(props){
    const initValue=props.value;
    const dispatch=useDispatch();
    const [currentTab,setCurrentTab]=useState("Contact Details");
    const tabs=["Contact Details","Bookings","Invoices"];
    const invoiceGuest= useSelector(({invoice})=>invoice && invoice.invoiceByGuest);
    const user = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting);

    useEffect(()=>{
        const id=initValue?initValue.id:null;
        if(id){
            dispatch(invoiceByGuest(id));
        }
    },[])

    const handleSubmit=(data)=>{
        const payload={
            id:(props.value)?props.value.id :undefined,
            name: data.name,
            emailId:data.emailId,
            phoneNo:data.phoneNo.split(" ")?.length ===1 ? "" : data.phoneNo,
            secondaryPhoneNo: data.secondaryPhoneNo.split(" ")?.length ===1 ? "" : data.secondaryPhoneNo,
            postalCode: data.postalCode,
            secondaryEmailId: data.secondaryEmailId,
            country: data.country,
            address: data.address,
            street: data.street,
            state:data.state,
            nationality:data.nationality,
            language:data.language,
            company:data.company,
            companyAddress:data.companyAddress,
            notes:data.notes,
            dob: data.dob ? moment(data.dob).format("YYYY-MM-DD") : ''
        }
        props.onSubmit(payload);
    }

    const phoneRegExp = /^[0-9-+\s()]*$/;

    const FormikEnhancer = withFormik({
        validationSchema:yup.object({
            name: yup.string().max(150, 'Must be 150 characters or less').required('Name is a required field'),
            company: yup.string().max(150, 'Must be 150 characters or less'),
            companyAddress: yup.string().max(150, 'Must be 150 characters or less'),
            emailId:yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
            secondaryEmailId :yup.string().max(150, 'Must be 150 characters or less').email('Invalid email'),
            phoneNo:yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.'),
            secondaryPhoneNo:yup.string().max(50, 'Must be 50 characters or less').matches(phoneRegExp, 'Only numbers, space, parenthesis, + and - are accepted.'),
            country: yup.string().max(50, 'Must be 50 characters or less'),
            address: yup.string().max(150, 'Must be 150 characters or less'),
            postalCode: yup.string().max(50, 'Must be 50 characters or less'),
            street: yup.string().max(150, 'Must be 150 characters or less'),
            state: yup.string().max(150, 'Must be 150 characters or less'),
            nationality:yup.string().max(150, 'Must be 150 characters or less'),
            language:yup.string().max(150, 'Must be 150 characters or less'),
            notes:yup.string().max(250, 'Must be 250 characters or less'),
            dob: yup.date().typeError('Must be a value of type date').nullable(),
        }),
        mapPropsToValues: () => ({
            id: initValue?.id || null,
            source: initValue?.source || '',
            name: initValue?.name || '',
            company: initValue?.company || '',
            companyAddress: initValue?.companyAddress || '',
            emailId: initValue?.emailId || '',
            secondaryEmailId: initValue?.secondaryEmailId || '',
            phoneNo: initValue?.phoneNo || '',
            secondaryPhoneNo: initValue?.secondaryPhoneNo || '',
            postalCode: initValue?.postalCode || '',
            state: initValue?.state || '',
            nationality: initValue?.nationality || '',
            language: initValue?.language || '',
            country: initValue?.country || user.country,
            address: initValue?.address || '',
            street: initValue?.street || '',
            dob: (initValue?.dob && initValue?.dob !== "Invalid da") ? new Date(moment(initValue.dob)) : null,
            notes: initValue?.notes || '',
        }),
        validateOnBlur:false,
        validateOnChange:false,
        handleSubmit :  (values, { setSubmitting }) => {
            handleSubmit(values);
            setSubmitting(false);
          },
        displayName: 'AddGuestForm',
      })(AddGuestForm);

    return(
      <>
          <div className={styles2.upperRow}>
              <a className={`${styles2.tabBox} ${styles2.tabButton}`} onClick={props.onHide}>
                  <span >
                      <ArrowBackIosIcon className={styles2.arrowIcon} />{"Back"}
                  </span>
              </a>
              {tabs.length!==0 && tabs.map((tab,index)=>(
                  <div key={index}>
                      {((tab==="Bookings" || tab==="Invoices") && !initValue) ?(
                         null
                      ):(
                          <a className={(currentTab===tab)?`${styles2.tabBox} ${styles2.active}`:`${styles2.tabBox}`} key={index} onClick={()=>setCurrentTab(tab)}>
                              {tab}
                          </a>
                      )}
                  </div>
              ))}
          </div>
          <div style={{margin:'0em 1em', padding: '1rem'}}>
              {currentTab==="Contact Details" && (
                  <FormikEnhancer/>
              )}
              {initValue && (
                  <>
                      {currentTab==="Bookings" && (
                          <GuestBookingList id={initValue? initValue.id:"1"} guestName={initValue?initValue.name:false}/>
                      )}
                      {currentTab==="Invoices" && (
                          <GuestInvoiceList invoiceGuest={invoiceGuest} guestDetail={initValue} guestName={initValue?initValue.name:false}/>
                      )}
                  </>
              )}
          </div>
      </>
    )
}
export default AddGuests;